// extracted by mini-css-extract-plugin
export var downArrow = "_b8-0";
export var infoTooltipIcon = "_b8-3";
export var label = "_b8-1";
export var optionCard = "_b8-4";
export var upArrow = "_b8-2";